export default {
  orderConfirm: {
    Addshippingaddress: '添加收货地址',
    cannotbedelivered: '该地址无法配送',
    Specifications: '规格',
    Optional: '选填',
    Order: '订单备注',
    Subtotal: '小计',
    Including: '含运费',
    Total: '合计',
    Submit: '提交订单',
    Ordernotes: '订单备注:',
    currently: '您目前没有创建任何地址！'
  }
}
